import Vue from 'vue'
import Toast from './toast.vue'
const defaultConfig = {
  type: 'loading',
  text: '加载中...',
  delay: 500,
  duration: 2000,
  onClose: () => {},
}
const ToastConstructor = Vue.extend(Toast)
const instance = {
  create() {
    if (!instance.toast) {
      instance.toast = new ToastConstructor({
        el: document.createElement('div'),
      })
      document.body.appendChild(instance.toast.$el)
    }
  },
  show(config) {
    instance.clear()
    instance.create()
    const mergedConfig = Object.assign({}, defaultConfig, config)
    instance.shower = window.setTimeout(() => {
      if ('duration' in mergedConfig) {
        instance.hider = window.setTimeout(() => {
          instance.hide()
        }, mergedConfig.duration)
      }
      instance.toast.show = true
      instance.toast.config = mergedConfig
    }, mergedConfig.delay)
  },
  hide() {
    instance.toast && (instance.toast.show = false) && instance.toast.config && instance.toast.config.onClose()
    instance.clear()
  },
  clear() {
    instance.shower && clearTimeout(instance.shower)
    instance.hider && clearTimeout(instance.hider)
  },
}

export default instance
